$(function() {

    $.material.init();

    $('#industry_sector').on('change', function(e) {
        if ( $(this).val() == 'other') {
            $('#other_industry_sector_wrapper').show(0);
        } else {
            $('#other_industry_sector_wrapper').hide(0);
        }
    });

});
